import {
  Box,
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
} from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";

type Props = {
  currentBlock: any;
};

const RadioField = ({ currentBlock }: Props) => {
  const dispatch = useAppDispatch();
  const label = currentBlock?.label;
  const choices = currentBlock?.config?.choices || [];
  const response = currentBlock?.response?.radioKey;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (currentBlock.editable)
      dispatch(
        updateResponse({
          blockId: currentBlock.id,
          key: "radioKey",
          value: event.target.value,
        })
      );
  };

  return (
    <Box>
      {label && (
        <Typography
          variant="h3"
          sx={{
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      )}

      <RadioGroup value={response ?? ""} onChange={handleChange}>
        {choices.map((choice: any) => (
          <FormControlLabel
            key={choice.key}
            control={<Radio inputProps={{ readOnly: true }} />}
            label={choice.label}
            value={choice.key}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default RadioField;
